import { Fragment } from "react";
import {
  Autocomplete,
  InputLabel,
  TextField,
  Typography,
  createFilterOptions,
  Chip,
} from "@mui/material";
import { Debounce } from "utils";

function SelectField(props) {
  const {
    label,
    size,
    custom,
    disabled,
    onSearch,
    addNew,
    multiple,
    selected,
    onSelect,
    register,
    error,
    // options,
       options = [],
    getOptionDisabled,
    recovery,
    multiline,
    bgColor,
    optional,
    renderTags = true,
    optionIdKey = "id",     
    optionLabelKey = "name",
    noOptionsText,
    placeholder,
  } = props;

  const filter = createFilterOptions();

  // *For Handle Filter Option
  const handleFilterOptions = (options, params) => {
    const filtered = filter(options, params);

    const { inputValue } = params;
    // *Suggest the creation of a new value
    const isExisting = options.some((option) => inputValue === option.name);
    if (inputValue !== "" && !isExisting && addNew) {
      filtered.push({
        inputValue,
        name: `Add "${inputValue}"`,
      });
    }

    return filtered;
  };

  // *For Handle Option Label
  const handleOptionLabel = (option) => {
    if (typeof option === "string") {
      return option;
    }
    // *Add new option created dynamically
    if (option.inputValue && addNew) {
      return option.inputValue;
    }
    // *Regular option
    return option.name || '';
  };

  // *For Handle Change
  const handleChange = (newValue) => {
    if (typeof newValue === "string") {
      onSelect(newValue);
      return;
    }
    if (newValue && newValue.inputValue && addNew) {
      addNew(newValue?.inputValue);
      return;
    }
    return onSelect(newValue);
  };

  // *For Handle Search
  const handleSearch = (value) => {
    if (onSearch) {
      Debounce(() => onSearch(value));
    }
  };
  return (
    <Fragment>
      <InputLabel
        // sx={{ color: "#323B4B" }}
        sx={custom ? custom : { textTransform: "capitalize", color: "#323B4B" }}
        error={error && selected === "" && true}
      >
        {label}
        {optional && (
          <span style={{ fontSize: "12px", fontWeight: 500 }}>(Optional)</span>
        )}
      </InputLabel>
      <Autocomplete
        disabled={disabled}
        size={size}
        noOptionsText={noOptionsText}
        multiple={multiple}
        isOptionEqualToValue={(option, value) => option?.name === value?.name}
        value={selected || ''}
        options={options}
        getOptionDisabled={props.getOptionDisabled}
        filterOptions={(options, params) =>
          handleFilterOptions(options, params)
        }
        getOptionLabel={(option) => handleOptionLabel(option)}
        onChange={(event, newValue) => handleChange(newValue)}
        onInputChange={(event, newInputValue) => handleSearch(newInputValue)}
        sx={{ mt: 1, mb: !error && 2 }}
        renderOption={(props, option) => (
          <li key={option.id} {...(Object.keys(props).reduce((acc, key) => {
            if (key !== 'key') acc[key] = props[key];
            return acc;
          }, {}))}>
            {option.name}
          </li>
        )}
        // renderOption={(props, option) => <li {...props}>{option.name}</li>}
        // renderTags={(value, getTagProps) =>
        //   value.map((option, index) => (
        //     <Chip
        //       variant="outlined"
        //       label={option.name}
        //       {...getTagProps({ index })}
        //       sx={{ maxWidth: '100%', mb: 0.5 }}
        //     />
        //   ))
        // }
        renderTags={
          renderTags === false
            ? () => null // disable chips completely
            : (value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={option?.[optionIdKey] ?? option?.[optionLabelKey] ?? index}
                  variant="outlined"
                  label={option?.[optionLabelKey]}
                  {...getTagProps({ index })}
                  sx={{ maxWidth: "100%", mb: 0.5 }}
                />
              ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder || label}
            error={error}
            {...register}
            InputProps={{
              ...params.InputProps,
              // startAdornment: recovery ? (
              //   <LocationIcon style={{ marginRight: "4px" }} />
              // ) : null,
              endAdornment: (
                <Fragment>{params.InputProps.endAdornment}</Fragment>
              ),

            }}
            sx={{
              backgroundColor: bgColor,
              borderRadius: "12px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: multiline ? "auto" : "45px",
                alignItems: "flex-start",
                paddingTop: '6px',
                paddingBottom: '6px',
              },
              "& .MuiInputBase-input": {
                height: "auto",
                boxSizing: "border-box",
                flexWrap: 'wrap',  // Allow tags to wrap inside the input field
              },
            }}
          />
          // <TextField
          //   {...params}
          //   placeholder={label}
          //   error={error}
          //   {...register}
          //   InputProps={{
          //     ...params.InputProps,
          //     endAdornment: (
          //       <Fragment>{params.InputProps.endAdornment}</Fragment>
          //     ),
          //   }}
          //   sx={{ backgroundColor: recovery ? "rgba(0,0,0,0.04)" : "#ffff" }}
          // />
        )}
      />
      {error && (
        <Typography variant="caption" color="error" sx={{ textAlign: "left" }}>
          {error}
        </Typography>
      )}
    </Fragment>
  );
}

export default SelectField;
